<template>
  <v-container>
    <div class="signin">
      <amplify-authenticator
        v-bind:authConfig="authConfig"
      ></amplify-authenticator>
    </div>
    <v-row>
      <v-col class="text-center">
        <p>
          Signing up signifies that you have read and agree to the
          <a href="/terms">Terms of Use</a>
          and our
          <a href="/privacy">Privacy Policy</a>
          .
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'signin',
  title: 'Sign in',
  headerTitle: 'Sign in',
  data() {
    return {
      authConfig: {
        usernameAttributes: 'email',
        signUpConfig: {
          header: 'Create a new account',
          hideAllDefaults: true,
          defaultCountryCode: '1',
          signUpFields: [
            {
              label: 'Email',
              key: 'email',
              required: true,
              displayOrder: 2,
              type: 'string',
              signUpWith: true,
            },
            {
              label:
                'Password (*Password must be at least 8 characters long, containing numbers, lowercase letters and uppercase letters)',
              key: 'password',
              required: true,
              displayOrder: 3,
              type: 'password',
            },
          ],
        },
      },
    }
  },
}
</script>

<style lang="scss">
.signin {
  & > div {
    text-align: center;
    & > div {
      min-width: auto;
    }
    button {
      background-color: #2196f3;
      &:active {
        background-color: #1565c0;
      }
    }
    .error {
      color: #ff5252 !important;
      background-color: transparent !important;
      margin-top: 16px;
    }
    @media screen and (min-width: 600px) {
      & > div {
        min-width: 460px;
      }
      .error {
        max-width: 380px;
      }
    }
  }
}
</style>
